import CHANNELS, { channelById } from '../../../../constants/Channels'
import { formatMoneyFromCurrencyCode } from '../../../../utils'
import ENABLED_CONCURRENT_CHANNEL_IDS from '../../../admin/listing_strategies/constants/EnabledConcurrentChannelIds'
import { Channel, Listing, ProjectedStep } from './types'

export function formatDateTime(date?: Date | string, includeTime = true) {
  const dateCopy = new Date(date)
  if (Number.isNaN(dateCopy.valueOf()) || !date) return null

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  }

  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' }

  return dateCopy.toLocaleString([], includeTime ? { ...dateOptions, ...timeOptions } : dateOptions)
}

export function resolveBinPrice(binPrice: number, channelId: number) {
  if (+binPrice === 0 && channelId === CHANNELS.SHOPGOODWILL.id) return null

  return binPrice
}

export function isConcurrentSwitchDisabled(listing: Listing): boolean {
  return [
    'LISTING',
    'MODIFYING',
    'DELISTING',
    'EXPIRING',
    'PURGING',
    'RELISTING',
    'PENDING_DELISTING',
    'PENDING_RELISTING',
    'PENDING_PURGING'
  ].includes(listing.state)
}

export function isConcurrentSwitchOn(listing: Listing): boolean {
  return [
    'LISTED',
    'LISTING',
    'MODIFYING',
    'RELISTING',
    'PENDING_RELISTING',
    'DELISTING_FAILED',
    'EXPIRING_FAILED'
  ].includes(listing.state)
}

export function resolveConcurrentSwitchState(listing: Listing): { isOn: boolean; disabled: boolean; message?: string } {
  if (!ENABLED_CONCURRENT_CHANNEL_IDS.includes(listing.marketId))
    return { disabled: true, isOn: false, message: 'Not supported to list concurrently' }

  if (listing.marketId === CHANNELS.OFFER_UP.id)
    return { disabled: true, isOn: isConcurrentSwitchOn(listing), message: 'Channel no longer available' }

  return {
    disabled: isConcurrentSwitchDisabled(listing),
    isOn: isConcurrentSwitchOn(listing)
  }
}

export function resolveAddableChannels(onboardedChannels: number[], listableChannels: number[]): Channel[] {
  const addableChannels = onboardedChannels
    .filter(channelId => !listableChannels.includes(channelId))
    .filter(channelId => channelId !== CHANNELS.GOODWILLFINDS.id)
    .filter(channelId => channelId !== CHANNELS.ETSY.id)
  return addableChannels.map(channelById)
}

export const formatMoneyWithListingCurrency = (amount, currencyCode) => {
  return formatMoneyFromCurrencyCode(amount, 2, '.', ',', currencyCode)
}

export const formatMoneyWithListingCurrencyRange = (amountStart, amountEnd, currencyCode) => {
  if (amountStart === amountEnd) {
    return formatMoneyWithListingCurrency(amountStart, currencyCode)
  }

  const startString = formatMoneyWithListingCurrency(amountStart, currencyCode)
  const endString = formatMoneyWithListingCurrency(amountEnd, currencyCode)
  return `${startString} - ${endString}`
}

export function attentionRequiredOnFutureSteps(futureSteps?: ProjectedStep[]) {
  if (!futureSteps) return false
  return futureSteps.some(step => Object.keys(step.errors || {}).length > 0 || step.listings.some(l => l.listingErrors))
}
